// extracted by mini-css-extract-plugin
export default {"root":"Autocomplete_root__ZHiEg"};